import React, { useMemo, useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Card } from 'antd'

import './index.less'

function square(title = '热门帖', list = []) {
  return (
    <Card className="hotArticle">
      <h2>{title}</h2>
      {list.map((item, index) => (
        <p
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            console.log('item', item)
            document.documentElement.scrollTop = document.body.scrollTop = 0
            window.location.href = `#/detail/${item.id}`
          }}
        >
          {item.title}
        </p>
      ))}
    </Card>
  )
}

export default square
